import { applyLandingBrand } from "@/lib/siteHosts"

export const sundayGapContent = applyLandingBrand({
  title: "The 10:14 PM Sunday Gap",
  lead: "Your office is closed. Your team is asleep. Competitors route to voicemail.",
  body:
    "The FractoLabs Infrastructure intercepts, qualifies, and locks the calendar slot in 26 seconds, before your competitor even sees the notification.",
  intercepted: "[Lead Intercepted]",
})
